/**
 * appCatalog.js — the list of third-party apps the Apps module knows about.
 *
 * This is intentionally a plain config array, not a database table: only
 * Gmail has a real connector today (backed by the existing email-insights
 * backend). Adding a new live connector later means implementing its own
 * backend module (same shape as email-insights-backend) and flipping its
 * `status` here to 'live' — no schema migration needed to plan for or list
 * an app before it's built.
 *
 * `logo` is a simple-icons entry (real, official, multi-color brand mark).
 * Slack and Microsoft Teams aren't in simple-icons (both delisted after
 * trademark takedown requests), so those two fall back to a lucide glyph
 * tinted with the brand's real color via AppIcon.
 */

import { siGmail, siJira, siAsana } from 'simple-icons';
import { Slack, Video } from 'lucide-react';

export const APP_CATALOG = [
  {
    id: 'gmail',
    name: 'Gmail',
    logo: siGmail,
    color: '#EA4335',
    status: 'live',
    description: 'Email response times and communication patterns.',
  },
  {
    id: 'jira',
    name: 'Jira',
    logo: siJira,
    color: '#0052CC',
    status: 'coming_soon',
    description: 'Ticket activity and resolution times.',
  },
  {
    id: 'asana',
    name: 'Asana',
    logo: siAsana,
    color: '#F06A6A',
    status: 'coming_soon',
    description: 'Task completion and project progress.',
  },
  {
    id: 'slack',
    name: 'Slack',
    icon: Slack,
    color: '#4A154B',
    status: 'coming_soon',
    description: 'Message response times across channels.',
  },
  {
    id: 'teams',
    name: 'Teams',
    icon: Video,
    color: '#6264A7',
    status: 'coming_soon',
    description: 'Meeting activity and chat responsiveness.',
  },
];

export function getApp(id) {
  return APP_CATALOG.find((a) => a.id === id) || null;
}
